import React, { useEffect, useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { Form } from "react-bootstrap";
import axios from 'axios';
import CountryDropdown from './CountryDropdown';
import CookieConsent from '../../pages/CookieConsent';
const Footer = ()=> {

  useEffect(() => {
    const intervalId = setInterval(() => {
      const links = document.querySelectorAll('.eapps-instagram-feed > a');
      links.forEach(link => link.remove());
    }, 2000);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);
    //let active = {textDecoration: "underline"};
    let activeClassName = "active nav-link";
    let defoltClassName = "nav-link";
    const [validated, setValidated] = useState(false);
    const [fromResMsg, setfromResMsg] = useState('');
    const [fromResError, setfromResError] = useState('');
    const [countryError, setCountryError] = useState({
      country: false,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    
    

    const handleSelectChange = (value) => {
    //const { value } = e.target;
    setFormData((prev) => ({ ...prev, country: value }));
    if (value !== "") {
      setCountryError((prev) => ({ ...prev, country: false }));
    }
    };

    const [formData, setFormData] = useState({
      email: '',
      country: ''
    });
  
    const handleChange = (e) => {
      //setFormData({ ...formData, [e.target.name]: e.target.value });
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async(e) => {
      e.preventDefault();
      const form = e.currentTarget;
      if(formData.country === ""){
        setCountryError((prev) => ({ ...prev, country: true }));
      }
      if(form.checkValidity() === false || formData.country === "") {
        e.stopPropagation();
        setValidated(true);
      } else {
        setValidated(true);
        //console.log("Form Data Submitted:", formData);
        //alert(`Form Submitted:\nEmail: ${formData.email}\nCountry: ${formData.country}`);
        try {
          const {data} = await axios.post(`${process.env.REACT_APP_API_URL}/subscription`, formData);
           //console.log(data);
           setValidated(false);
           setFormData({
             email: '',
             country:''
           });
           setfromResMsg(data.message);          
           setIsSubmitting(false);
           setfromResError('');
       } catch (error) {
           setfromResMsg('');
           const {data} = error.response;
           setfromResError(data[0].message);
           setIsSubmitting(false);
       }
      }

    };

  return (
    <>
    {/* <div className="whats-app-wrap"><p><span>Write to us on <Link target='_blank' to="&#109;&#97;&#105;&#108;&#116;&#111;&#58;&#99;&#117;&#115;&#116;&#111;&#109;&#101;&#114;&#99;&#97;&#114;&#101;&#64;&#99;&#104;&#97;&#97;&#115;&#104;&#110;&#105;&#99;&#111;&#117;&#116;&#117;&#114;&#101;&#46;&#99;&#111;&#109;" className="mailto-box">&#99;&#117;&#115;&#116;&#111;&#109;&#101;&#114;&#99;&#97;&#114;&#101;&#64;&#99;&#104;&#97;&#97;&#115;&#104;&#110;&#105;&#99;&#111;&#117;&#116;&#117;&#114;&#101;&#46;&#99;&#111;&#109;</Link> or <Link  target="_blank" to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}`} rel="noopener noreferrer" className="whatapp-icon">Whatsapp us</Link></span></p></div> */}
<div className="whats-app-wrap"><p><span>Write to us on <Link target='_blank' to={`mailto:${process.env.REACT_APP_EMAIL_ID}`} className="mailto-box">{process.env.REACT_APP_EMAIL_ID}</Link> or <Link  target="_blank" to={`https://wa.me/${process.env.REACT_APP_WHATSAPP_NO}`} rel="noopener noreferrer" className="whatapp-icon">Whatsapp us</Link></span></p></div>    
    
    <div className="section footer-box">
    <div className="container">
      <div className="row">
        <div className="col-md-3 col-sm-3 col-xs-12 shop-footer">
          <h2>SHOP</h2>
          <div className="menu-shop-footer-container">
           {/* <Category /> */}
           <ul>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/indo-westerns?category_product=indo-westerns_indo-westerns-the-ruhani-edit_indo-westerns-the-manchali-edit_indo-westerns-the-glam-edit&orderBy=default">Indo Westerns</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/festive-flair?category_product=festive-flair&orderBy=default">Festive Flair (Kurta Sets)</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/lehengas?orderBy=default&category_product=lehengas_printed-lehengas_the-signature-edit_the-regal-collection_the-timeless-collection_the-sleek-edit">Lehengas</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/lehenga-sarees?category_product=lehenga-sarees&orderBy=default">Lehenga Sarees</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/stitched-sarees?category_product=stitched-sarees&orderBy=default">Stitched Sarees</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/sarees?category_product=sarees&orderBy=default">Sarees</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/gowns?category_product=gowns_gowns-signature-edit_gowns-the-timeless-collection&orderBy=default">Gowns</NavLink></li>            
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/the-chic-edit?orderBy=default&category_product=the-chic-edit">The Chic Edit (Westerns)</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/shop?shipping=7+Days&orderBy=default">Ready To Ship</NavLink></li>
            <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/category/sample-sale?category_product=sample-sale&orderBy=default">SALE</NavLink></li>
          </ul>
          </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12 links-footer">
          <h2>LINKS</h2>
          <div className="menu-footer-link-menu-container">
            <ul id="menu-footer-link-menu" className="menu">
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/about">About</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/celebrity">Celebrities in Chaashni</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/clientdiaries">Client Diaries</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/testimonial">Client Speak</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/faq">FAQ</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/blog">Blog</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/reviews">Reviews</NavLink></li>               
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/returns-exchanges-and-cancellations">Returns, Exchanges and Cancellations</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/privacy-policy">Privacy Policy</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/terms-conditions">Terms &amp; Conditions</NavLink></li>
              {/* <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  target="_blank" rel="noopener noreferrer" to="http://chaashniforyou.com/ecommerce/sitemap.xml">Sitemap</NavLink></li> */}
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/shipping-information">Shipping Information</NavLink></li>
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/pages/copyright-policy">Copyright Policy</NavLink></li>                
              <li><NavLink className={({ isActive }) => isActive ? activeClassName : defoltClassName}  to="/contact">Contact Us</NavLink></li>
            </ul>
          </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12 signup-footer">
        <div className='footer-middle'>
          <div className="signup-box">            
            {/* <p>Stay Updated with our <strong>Latest Launches</strong>, <br /> <strong>100% Free Give-Aways</strong> and <strong>Discount Coupons.</strong> </p> */}
            <p>Get regular updates on <strong>NEW COLLECTION</strong>,<br /> <strong>FREE GIVE AWAYS</strong> and <strong>DISCOUNT CODES</strong></p>            
            <div className="newsletter" id="fsuccess">
              <Form noValidate validated={validated} onSubmit={handleSubmit} className="form-inline googleform-footer">
                <div className="newsletter-box-wrap">
                <div className="newsletter-box-wrap-new">
                  <div className='newsletter-box-40'><CountryDropdown hasError={countryError.country} onSelectChange={handleSelectChange} /></div>
                  <div className='newsletter-box-60'><input type="text" name="email" required placeholder="Your Email or Whatsapp No." onChange={handleChange} value={formData.email} className="form-control"/></div>
                </div>
                <div className="newsletter-submit-wrap-new">
                  <input type="submit" value="SIGN UP" className="btn btn-primary"  disabled={isSubmitting}/>
                </div>
                  {fromResMsg && (
                     <label className="success-msg">{fromResMsg}</label>
                  )}
                   {fromResError && (
                    <label className="text-danger">{fromResError}</label>
                 )} 
                 
                </div>                
              </Form>
            </div>
            <p className="small-text">Only Meaningful Rare Messages. <br /> We will not share your details with only third party</p>
          </div>
          <div className="social-media">
            <span>STAY IN TOUCH</span>
            <Link to="https://www.facebook.com/chaashni.couture/" target="_blank"><img src="/images/fb-img.png" alt=""  width="28px" height="28px"/></Link>
            {/* <Link to="https://www.youtube.com/channel/UC3XLW6h4EpDTrN2VdDLKx3w" target="_blank"><img src="/images/yt-img.png"  alt="" width="28px" height="28px" /></Link> */}
            <Link to="https://www.instagram.com/chaashni.couture/" target="_blank"><img src="/images/inst-img.png" alt=""  width="28px" height="28px"/></Link>
          </div>
          </div>
        </div>
        <div className="col-md-3 col-sm-3 col-xs-12 safe-footer">
          {/* <h2>100% SAFE and SECURE <br /> PAYMENT METHODS</h2>
          <p>We accept Netbanking of all major Banks, <br />Credit Cards and Debit Cards.</p>
          <img src="/images/Footer.jpg" width="304px" height="111px" alt="" /> */}
          <div className='footer-middle'>{/* <img src="/images/footer-img.png" alt="" /> */}
            <div className="features">
  <div className="feature-box">
    <i className="fa-solid fa-award"></i>
    <p>Assured <br /> Quality</p>
  </div>

  <div className="feature-box">
    <i className="fa-solid fa-shield-halved"></i>
    <p>Purchase <br /> Protection</p>
  </div>

  <div className="feature-box">
    <i className="fa-solid fa-globe"></i>
    <p>Shipping <br /> Worldwide</p>
  </div>

  <div className="feature-box">
    <i className="fa-solid fa-tags"></i>
    <p>Best Price <br /> Guaranteed</p>
  </div>
</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer className="footer-area"> 
  <div className="container">
    <div>Copyright © {new Date().getFullYear()} Chaashni Couture. <span className='sitemap-link'>{/* <NavLink target="_blank" to="/sitemap.xml">Sitemap</NavLink> */}</span></div>
    {/* <div>A unit of M/s ANTYA</div> */}
  </div>
</footer>
<CookieConsent/>
</>
  )
}
export default Footer
